import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { EstadosTallerConstant } from 'constants/index'

const EstadoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='ESTADO' htmlFor='select-estado' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='estado'>
          {({ field }) => (
            <Form.Select {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='select-estado'>
              {EstadosTallerConstant.__array.map(x => (
                <option key={x.id} value={x.id}>
                  {x.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(EstadoFormGroup)
